<template>

	<div class="board_list">
		<ul class="faq_list">

			<li v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" :style="{ color : item.opt3 }" @click="goView(item)" :id="'dt-' + item.idx">
					<div class="q">Q.</div>
					<em class="cate">{{ item.cateName }}</em>
					<strong class="tit">{{ item.title }}</strong>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>

import $ from 'jquery'

export default {
	name: "listFaq",
	components: {},
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goBoardOne( _idx ) {
			this.$emit("goBoardOne", _idx);
		},

		openAnwer(e) {

			// console.log( e.currentTarget.id )
			const dom = "#" + e.currentTarget.id

			// 아코디언 리스트
			$(".type-accordion dd").hide();
			if (!$(dom).parent("dl").hasClass("active")) {
				$(".type-accordion dl").removeClass("active");
				$(".type-accordion dd").slideUp(250);
				$(dom).parent("dl").addClass("active");
				$(dom).siblings("dd").slideDown(250);

				this.webUtils.scrollTo(dom);
			} else {
				$(dom).parent("dl").removeClass("active");
				$(dom).siblings("dd").slideUp(250);
			}
		},

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}


	},
	watch: {
		'boardList': (newVal, oldVal) => {
			//console.log( newVal )
		}
	}
}
</script>

<style scoped>

</style>
